import InboxButton from '../../components/tools/InboxButton/InboxButton';
import { connect } from 'react-redux';
import { hideTools, setCenterPaneExtraInfoPanelActive } from '../../actions/index';
import { eraseRecommendationRegExFromTextInput } from 'actions/CommerceWizardActions';
import { getShowToolsState, isCommerceWizardActive, getSimplrTaggingActive } from '../../extractFromState';

const mapStateToProps = (state) => ({
  toolsOpen: getShowToolsState(state),
  simplrTaggingActive: getSimplrTaggingActive(state),
  commerceWizardActive: isCommerceWizardActive(state),
});

const mapDispatchToProps = (dispatch) => ({
  hideTools() {
    dispatch(hideTools());
  },
  closeCommerceWizard() {
    dispatch(eraseRecommendationRegExFromTextInput());
    dispatch(setCenterPaneExtraInfoPanelActive(false, null));
  },
});

const InboxButtonContainer = connect(mapStateToProps, mapDispatchToProps)(InboxButton);

export default InboxButtonContainer;
